// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  height: 100%;
}

.right-panel {
  height: 100%; /* the outer container */
  display: flex;
  flex-direction: column;
}

.middle-container {
  flex: 1 1; /* take all remaining space */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.grid-container {
  flex: 1 1;
  display: grid;
  grid-template-columns: 4.5fr 1.5fr;
  gap: 1rem;
  height: 100%;
}

.sub-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}


`, "",{"version":3,"sources":["webpack://./src/components/NoteBook.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY,EAAE,wBAAwB;EACtC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO,EAAE,6BAA6B;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd","sourcesContent":["html, body, #root {\n  height: 100%;\n}\n\n.right-panel {\n  height: 100%; /* the outer container */\n  display: flex;\n  flex-direction: column;\n}\n\n.middle-container {\n  flex: 1; /* take all remaining space */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.grid-container {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 4.5fr 1.5fr;\n  gap: 1rem;\n  height: 100%;\n}\n\n.sub-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
